import { ReactNode } from 'react'
import PermitHeader from './PermitHeader'
import PermitFooter from './PermitFooter'

const Wrapper = ({ title, children }: { title: string, children: ReactNode }) => {
    return (
        <div className="flex flex-col">
            <div
                id="pdf-content-page-1"
                className="w-full mx-auto p-8 text-black space-y-1.5 flex flex-col justify-between"
                style={{
                    fontFamily: "Arial, sans-serif",
                    height: "1100px",
                    pageBreakAfter: "always",
                }}
            >
                <div className="space-y-1.5">
                    <PermitHeader title={title} />

                    <div className="border-x border-t border-black">
                        {children}
                    </div>
                </div>

                <PermitFooter />
            </div>
        </div>
    )
}

export default Wrapper
